import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { STAT_PERIODS } from 'constants/dashboard';
import { apiClient, withMinDelayThunk } from 'utils/api';

export const fetchSummary = createAsyncThunk(
  'dashboard/fetchSummary',
  withMinDelayThunk(async (range, { rejectWithValue }) => {
    try {
      const response = await apiClient.get('/stats/summary', { params: { range } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch dashboard stats');
    }
  })
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    statPeriod: STAT_PERIODS.DAY,
    summary: null,
    summaryStatus: 'idle',
    summaryError: null,
  },
  reducers: {
    setStatPeriod(state, action) {
      state.statPeriod = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummary.pending, (state) => {
        state.summaryStatus = 'loading';
        state.summaryError = null;
      })
      .addCase(fetchSummary.fulfilled, (state, action) => {
        state.summaryStatus = 'succeeded';
        state.summary = action.payload.data;
      })
      .addCase(fetchSummary.rejected, (state, action) => {
        state.summaryStatus = 'failed';
        state.summaryError = action.payload;
      });
  },
});

export const { setStatPeriod } = dashboardSlice.actions;

export const selectStatPeriod = (state) => state.dashboard.statPeriod;
export const selectSummary = (state) => state.dashboard.summary;
export const selectSummaryStatus = (state) => state.dashboard.summaryStatus;
export const selectSummaryError = (state) => state.dashboard.summaryError;

export default dashboardSlice.reducer;
